// extracted by mini-css-extract-plugin
export default {"twoFactorAuthSMS":"auth__twoFactorAuthSMS__PXuBf4","formItem":"auth__formItem__ZZMzpf"};